import Axios, { AxiosResponse } from 'axios';
import { AxiosRequestConfig } from 'axios';
import * as _ from 'lodash';

const blackApiList: string[] = [
    'api/users/login'
];

if (process.env.NODE_ENV === 'development') {
    window.API_ROOT = "https://kid.i-tcm.cn/";
} else if (process.env.VUE_APP_ENV === 'test') {
    window.API_ROOT = "https://kid-test.i-tcm.cn/";
} else if (process.env.VUE_APP_ENV === 'production') {
    window.API_ROOT = "https://kid.i-tcm.cn/";
}

const baseConfig: AxiosRequestConfig = {
    baseURL: window.API_ROOT,
};
const axios = Axios.create(baseConfig);
const ifAddAuthorization = (config: AxiosRequestConfig): AxiosRequestConfig => {
    const token = localStorage.getItem('token');
    if (token && typeof (token) === 'string' && token !== 'undefined') {
        const url = config.url;
        let isBlack = false;
        for (const api of blackApiList) {
            if (url && url.includes(api)) {
                isBlack = true;
            }
        }
        if (isBlack) {
            delete config.headers.common.Authorization;
        } else {
            config.headers.common.Authorization = '' + 'Bearer ' + token;
        }
    } else {
        console.log(token);
    }
    return config;
};
axios.interceptors.request.use((config: AxiosRequestConfig) => {
    config = ifAddAuthorization(config);
    return config;
});

axios.interceptors.response.use((value: AxiosResponse) => {
    return value;
}, (error: any) => {
    console.log(error);
});

export default axios;


const axiosM = Axios.create({
    baseURL: 'http://data-test.i-tcm.cn/',
});
const authorization = (config: AxiosRequestConfig): AxiosRequestConfig => {
    const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1c2VyNWU0MGM2NDk0NzkyM2UwMDExZjU1ODFhIiwiaWF0IjoxNjI3MzU1ODg5LCJleHAiOjE2NDI5MDc4ODl9.gh6hu3ufB8vu0UFF54XL2lqHuZpDnCahWqMMAKZl3O4';
    if (token && typeof (token) === 'string') {
        const url = config.url;
        let isBlack = false;
        for (const api of blackApiList) {
            if (url && url.includes(api)) {
                isBlack = true;
            }
        }
        if (isBlack) {
            delete config.headers.common.Authorization;
        } else {
            config.headers.common.Authorization = '' + 'Bearer ' + token;
        }
    } else {
        console.log(token);
    }
    return config;
};
axiosM.interceptors.request.use((config: AxiosRequestConfig) => {
    config = authorization(config);
    return config;
});

axiosM.interceptors.response.use((value: AxiosResponse) => {
    return value;
}, (error: any) => {
    console.log(error);
});
// const axiosM = Axios.create({
//     baseURL: window.MOCK_ROOT,
// });
export { axiosM };

const axiosC = Axios.create({
    baseURL: window.COMPLETE_MOCK_ROOT,
});
export { axiosC };

const axiosD = Axios.create({
    baseURL: window.COMPLETE_MOCK_ROOT,
});
export { axiosD };

const resHandle = (VueComponent: any, data: any) => {
    return new Promise((resolve, reject) => {
        if (data.error_code !== 0) {
            VueComponent.$message({
                type: "error",
                message: data.msg
            });
            reject(data.msg);
        } else {
            resolve(data);
        }
    });
};

export { resHandle };
